import { Theme, Typography, withStyles } from '@material-ui/core';
import { BlocTextes, Button, Card, LoadingIcon, Snack } from 'bc-front-sagacomponents';
import { useEffect, useState } from 'react';
import { buildTarif, datePlusOneDay } from '../../../helpers/formatters';
import { AdhesionAdherentParticulierResponse } from '../../../services/Api/swagger';
import BlocContact from '../BlocContact';
import { useRenouvellement } from '../hooks/renouvellement';
import styles from '../style';
import Cheque from './Cheque';
import { modeRenouvellement, TypeMode } from './helpers';
import PaiementCB from './PaiementCB';
import Prelevement from './Prelevement';

interface Props {
  classes?: any;
  selectedAdhesion?: AdhesionAdherentParticulierResponse;
  width: number;
  theme?: Theme;
  //  listeAdhesions: AdhesionAdherentParticulierResponse[];
}
const RenouvellementContent = (props: Props) => {
  const { classes, width, selectedAdhesion, theme } = props;

  const [selection, setSelection] = useState<TypeMode | undefined>();
  const [confirmationMandat, setConfirmationMandat] = useState<boolean>(false);

  const {
    isPeriodRenouvellement,
    fetchingRenouvellement,
    errorRenouvellement,
    isTransactionEnCours,
    responseRenouvellement,
    returnPaiement,
    setReturnPaiement,
  } = useRenouvellement(selectedAdhesion);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paiement = params.get('paiement');
    if (isTransactionEnCours || paiement) {
      setSelection('cb');
    } else {
      setSelection(undefined);
    }
    if (paiement === 'ok') {
      setReturnPaiement('success');
    } else if (paiement === 'ko') {
      setReturnPaiement('error');
    } else {
      setReturnPaiement(undefined);
    }
  }, [isTransactionEnCours, window.location.search]);

  const disabledRenouvellement =
    !isPeriodRenouvellement || isTransactionEnCours || (selectedAdhesion && selectedAdhesion.mandat !== null);
  return (
    <div className={classes.blocRenouvellement}>
      {returnPaiement && (
        <Snack
          onClose={() => setReturnPaiement(undefined)}
          message={
            returnPaiement === 'success'
              ? 'Votre demande a bien été pris en compte.<br /> Vous recevrez prochainement la confirmation de votre renouvellement'
              : 'Une erreur est survenue. Veuillez réessayer.<br /> Si le problème persiste, contacter Saga Service Plus.'
          }
          type={returnPaiement}
        />
      )}{' '}
      {confirmationMandat && (
        <Snack
          onClose={() => setConfirmationMandat(false)}
          type="success"
          message="Votre renouvellement a bien été pris en compte. Vous recevrez un courrier de confirmation avec votre échéancier de paiement"
        />
      )}
      <Card>
        <Typography variant="h4">Renouveler mon contrat</Typography> <br />
        <BlocTextes
          red
          title=" "
          content={[
            {
              title: 'Tarif mensuel',
              value:
                (responseRenouvellement?.tarif &&
                  buildTarif(Math.round((responseRenouvellement?.tarif / 12) * 100) / 100)) ||
                '-',
            },
            {
              title: 'Tarif annuel',
              value:
                (responseRenouvellement?.tarif &&
                  buildTarif(Number.parseFloat(responseRenouvellement.tarif.toString()).toFixed(2))) ||
                '-',
            },
            {
              title: 'Tarif annuel',
              value: (responseRenouvellement?.tarif && buildTarif(responseRenouvellement.tarif)) || '-',
            },
          ]}
        ></BlocTextes>
        <Typography variant="body1">
          Deux mois avant l’expiration de vos prestations, vous recevrez un premier courrier par voie postale ou par
          mail pour procéder au renouvellement de votre adhésion. Vous avez la possibilité de renouveler votre adhésion
          et de régler votre cotisation en ligne via notre site de paiement sécurisé en cliquant sur “Choisir” parmi les
          options ci-dessous.
        </Typography>
        {!fetchingRenouvellement && !errorRenouvellement && selectedAdhesion && (
          <div className={classes.modeContainer}>
            {modeRenouvellement.map((mode) => {
              let className = classes.mode;
              if (selection === mode.id) {
                className += ' ' + classes.active;
              }
              return (
                <div className={className}>
                  <Typography variant="body1">
                    <strong>{mode.title}</strong>
                  </Typography>
                  <Typography variant="body2">{mode.texte}</Typography>
                  {mode.id === 'cb' && !isTransactionEnCours ? (
                    <PaiementCB
                      numeroAdhesion={selectedAdhesion.numeroAdhesion}
                      renouvellement={responseRenouvellement}
                      disabledRenouvellement={disabledRenouvellement}
                    />
                  ) : (
                    <Button
                      title="Choisir"
                      variant="contained"
                      color="secondary"
                      disabled={disabledRenouvellement}
                      onClick={() => setSelection(mode.id)}
                    />
                  )}
                </div>
              );
            })}
          </div>
        )}
        {fetchingRenouvellement && <LoadingIcon />}
        {errorRenouvellement && (
          <Typography color="error">Impossible de récupérer les informations sur le renouvellement</Typography>
        )}
        {selection === 'cheque' && <Cheque />}
        {selection === 'prelevement' && selectedAdhesion && !selectedAdhesion.mandat && (
          <Prelevement
            selectedAdhesionId={selectedAdhesion && selectedAdhesion.numeroAdhesion}
            setConfirmationMandat={setConfirmationMandat}
            confirmationMandat={confirmationMandat}
          />
        )}
        {isTransactionEnCours && (
          <Typography variant="body1">
            Votre renouvellement a bien été pris en compte. Vous recevrez prochainement un courrier de confirmation
          </Typography>
        )}
        {selectedAdhesion && selectedAdhesion.mandat && (
          <Typography variant="body1">
            Le dernier renouvellement ayant été fait par prélèvement, la tacite reconduction s’applique et vos
            prestations sont renouvélées à partir du{' '}
            {selectedAdhesion && selectedAdhesion.dateEcheance && datePlusOneDay(selectedAdhesion.dateEcheance)}
          </Typography>
        )}
      </Card>
      <br />
      {width < 899 && (
        <Card>
          <BlocContact theme={theme} />
        </Card>
      )}
    </div>
  );
};
export default withStyles(styles)(RenouvellementContent);
